import React, { useEffect, useState } from 'react';

import Topbar from './component/Topbar';
import NavbarElement from './component/Navbar';
import Fab from './component/Fab';
import Footer from './component/Footer';
import StringRes from './component/StringResources';

const HYDRATION_PAGE_WIDTH = 1280;

function Layout({ children, renderChildren, lang = 'lt' }) {
  const scrollYOffset = 44;
  const [onTop, setOnTop] = useState(true);
  useEffect(() => {
    const onScroll = () => setOnTop(window.scrollY <= scrollYOffset);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const [pageWidth, setPageWidth] = useState(HYDRATION_PAGE_WIDTH);
  useEffect(() => {
    setPageWidth(window.innerWidth);
    const onResize = () => setPageWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const strings = StringRes(lang);
  const ctx = { strings, lang, pageWidth, onTop };

  return (
    <div className="flex-wrapper">
      <Topbar strings={strings} pageWidth={pageWidth} />
      <NavbarElement
        strings={strings}
        pageWidth={pageWidth}
        onTop={onTop}
        lang={lang}
      />
      <main>
        {renderChildren ? renderChildren(ctx) : children}
      </main>
      <Fab onTop={onTop} />
      <Footer />
    </div>
  );
}

export default Layout;
